module.exports = __webpack_public_path__ + "static/about-investition5-f14a8b6f911c9b08cfa2e2bb593b2eb6.jpg";